export default "__VITE_ASSET__bda524cf__"